export default "__VITE_ASSET__DMt4WbhL__"